import React, { useContext, useEffect, useState } from 'react'
import { Table, Button } from 'react-bootstrap'
import { LanguageContext } from '../Language/LanguageContext'
import { listFeedback } from '../Network/Feedback'
import { Loading } from '../Library'
import dayjs from 'dayjs'
import { useHistory } from 'react-router-dom'
import "./FeedbackResponse.css"
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faAsterisk, faCheckCircle, faPaperclip } from '@fortawesome/free-solid-svg-icons'

function FeedbackResponse() {
    const langCx = useContext(LanguageContext)
    const lang = langCx.lang.administration
    const history = useHistory()
    const [isLoading, setLoading] = useState(false)
    const [listFeedbacks, setListFeedbacks] = useState([])

    const fetchData = () =>{
        setLoading(true)
        listFeedback(
            (data)=>{
                setListFeedbacks(data)
                setLoading(false)
            },
            (error)=>{
                setLoading(false)
            }
        )
    }
    
    useEffect(()=>{
        fetchData()
    },[])

    return (
        <div id="feedback-res">
            { isLoading ? <Loading/>: null }
            <div className="table-container">
                <Table hover>
                    <thead>
                        <tr>
                            <th></th>
                            <th>{lang.title}</th>
                            <th>{lang.user}</th>
                            <th>{lang.datetime}</th>
                            <th>{lang.action}</th>
                        </tr>
                    </thead>
                    <tbody>
                        { listFeedbacks.map((item, key) => 
                        <FeedbackRow
                        key={key}
                        title={item.title}
                        user={item.user.firstName + " " + item.user.lastName}
                        datetime={item.createdDate}
                        isSolve={item.isSolved}
                        isAttach={item.attachImagePath !== null ? true : false}
                        onClickDetail={()=>history.push("/feedback/"+item.id)}
                        />
                        )}
                    </tbody>
                </Table>
            </div>
        </div>
    )
}

function FeedbackRow({ title, user, datetime, isSolve, isAttach, onClickDetail }){
    const langCx = useContext(LanguageContext)
    const lang = langCx.lang.administration

    return(
        <tr>
            <td className="solve-col">
                { !isSolve ?
                <FontAwesomeIcon icon={faAsterisk} color="orange"/>
                : 
                <FontAwesomeIcon icon={faCheckCircle} color="green"/>
                }
                { isAttach ?
                <FontAwesomeIcon icon={faPaperclip} style={{ marginLeft: 10 }} color="gray"/>
                : null
                }
            </td>
            <td>{title}</td>
            <td>{user}</td>
            <td>{dayjs(datetime).format("D MMMM YYYY H:mm")}</td>
            <td style={{ width: 130 }}>
                <Button size={"sm"} onClick={onClickDetail}>
                    {lang.detail}
                </Button>
            </td>
        </tr>
    )
}

export default FeedbackResponse
